const sectionTitle = "Users";

export default [
  {
    path: "/sso-callback/",
    name: "sso-callback",
    component: () => import("@/views/SsoCallback.vue"),
    meta: {
      layout: "public",
      hideTopbar: true,
      title: sectionTitle,
      group: "Users",
    },
  },
  {
    path: "/profile/",
    name: "user-profile",
    component: () => import("@/features/users/components/UserProfile.vue"),
    meta: {
      layout: "app",
      title: sectionTitle,
      group: "Users",
      requiresAuth: true,
    },
  },
  {
    path: "/account-deactivate/",
    name: "account-deactivate",
    component: () => import("@/features/users/components/DeactivateAccount.vue"),
    meta: {
      layout: "public",
      hideTopbar: true,
      title: "Account deactivated",
      group: "Users",
    },
  },
];
